import { render } from "./AppSvgBack.vue?vue&type=template&id=d1ad942a&scoped=true"
import script from "./AppSvgBack.vue?vue&type=script&lang=js"
export * from "./AppSvgBack.vue?vue&type=script&lang=js"

import "./AppSvgBack.vue?vue&type=style&index=0&id=d1ad942a&lang=scss&scoped=true"

import exportComponent from "/Users/patriksvensson/Documents/Projects/KK/bygdrift/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1ad942a"]])

export default __exports__